(function() {
    function convertProductDescriptionH1ToH2() {
      var frames = document.querySelectorAll('.slr-product-description-frame__content');

      frames.forEach(function(frame) {
        var h1Headings = frame.querySelectorAll('h1');

        h1Headings.forEach(function(h1) {
          var h2 = document.createElement('h2');

          Array.prototype.slice.call(h1.attributes).forEach(function(attribute) {
            h2.setAttribute(attribute.name, attribute.value);
          });

          while (h1.firstChild) {
            h2.appendChild(h1.firstChild);
          }

          h1.parentNode.replaceChild(h2, h1);
        });
      });
    }

    function removeEmptyProductDescriptionHeadings() {
      var frames = document.querySelectorAll('.slr-product-description-frame__content');

      frames.forEach(function(frame) {
        var headings = frame.querySelectorAll('h2, h3, h4, h5, h6');

        headings.forEach(function(heading) {
          var text = heading.textContent.replace(/\u00a0/g, ' ').trim();
          var hasVisualContent = heading.querySelector('img, svg, video, iframe');

          if (!text && !hasVisualContent) {
            heading.remove();
          }
        });
      });
    }

    function forceProductDescriptionFullWidth() {
      var frames = document.querySelectorAll('.slr-product-description-frame__content');
      var fullWidthSelector = [
        'div',
        'section',
        'article',
        'header',
        'footer',
        'main',
        'aside',
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'ul',
        'ol',
        'table',
        'thead',
        'tbody',
        'tfoot',
        'tr',
        'td',
        'th',
        '.rte',
        '.metafield-rich_text_field'
      ].join(',');

      frames.forEach(function(frame) {
        frame.style.width = '100%';
        frame.style.maxWidth = '100%';
        frame.style.minWidth = '0';
        frame.style.border = '0';
        frame.style.outline = '0';

        frame.querySelectorAll(fullWidthSelector).forEach(function(element) {
          element.style.width = '100%';
          element.style.maxWidth = '100%';
          element.style.minWidth = '0';
          element.style.marginLeft = '0';
          element.style.marginRight = '0';
        });

        frame.querySelectorAll('h2, h2 *').forEach(function(element) {
          element.style.fontSize = window.matchMedia('(max-width: 749px)').matches ? '24px' : '30px';
          element.style.lineHeight = '1.15';
          element.style.fontFamily = 'Anton, Impact, sans-serif';
          element.style.fontWeight = '400';
          element.style.color = '#000000';
        });

        frame.querySelectorAll('p, p *, li, li *').forEach(function(element) {
          element.style.fontSize = window.matchMedia('(max-width: 749px)').matches ? '17px' : '21px';
          element.style.lineHeight = window.matchMedia('(max-width: 749px)').matches ? '1.45' : '1.42';
          element.style.fontFamily = 'Poppins, Arial, sans-serif';
          element.style.color = '#242833';
        });
      });
    }

    function cleanProductDescriptionFrame() {
      convertProductDescriptionH1ToH2();
      removeEmptyProductDescriptionHeadings();
      forceProductDescriptionFullWidth();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cleanProductDescriptionFrame);
    } else {
      cleanProductDescriptionFrame();
    }

    document.addEventListener('shopify:section:load', cleanProductDescriptionFrame);
    window.addEventListener('resize', cleanProductDescriptionFrame);
  })();
